import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import { LastLocationProvider } from 'react-router-last-location';
import Layout from 'blocks/Layout';
import BlogArticle from 'pages/BlogArticle';
import ANCHOR from 'common/consts/anchor';
import Product from 'pages/Product';
import ForInvestors from 'pages/ForInvestors';
import Blog from 'pages/Blog';
import Regulations, { AppRegulations } from 'pages/Regulations';
import PrivacyPolicy from 'pages/PrivacyPolicy';
import PageNotFound from 'pages/PageNotFound';
import ContactFormPage from 'pages/ContactForm';
import NewsletterThankYouPage from 'pages/NewsletterThankYouPage';
import PropTypes from 'prop-types';
import { prepareAnchors, rootPathJoin } from './common/methods/language';
import { AppStore } from './stores/App.store';
import getDataFromURL from 'services/Inbound.service';

@inject('appStore')
@observer
class App extends Component {
  static propTypes = {
    appStore: PropTypes.instanceOf(AppStore).isRequired,
  };

  constructor(props) {
    super(props);
    getDataFromURL();
    this.state = {
      anchor: prepareAnchors(props.appStore.currentLanguage, ANCHOR),
    };
  }

  render() {
    const { appStore } = this.props;
    const { anchor } = this.state;
    appStore.setUrlHistory();

    return (
      <LastLocationProvider>
        <Layout>
          <Switch>
            {appStore.currentLanguage==="pl" && <Route exact path={anchor.FOR_INVESTORS} component={ForInvestors} />}
            <Route path={anchor.CONTACT_FORM} component={ContactFormPage} />
            <Route path={anchor.THANK_YOU} component={NewsletterThankYouPage} />
            <Route
              path={anchor.SUBSCRIPTION_CONFIRMED}
              render={props => <NewsletterThankYouPage confirmed {...props} />}
            />
            <Route exact path={anchor.REGULATIONS} component={Regulations} />
            {/* Temporary route is switched off */ }
            {/* <Route */}
            {/*  exact */}
            {/*  path={anchor.APPLICATION_REGULATIONS} */}
            {/*  component={AppRegulations} */}
            {/*  /> */}
            <Route
              exact
              path={anchor.PRIVACY_POLICY}
              component={PrivacyPolicy}
              />
            <Route
              exact
              path={rootPathJoin(anchor.BLOG, '/:category/:slug')}
              component={BlogArticle}
              />
            <Route
              exact
              path={rootPathJoin(anchor.BLOG, '/:category?')}
              component={Blog}
              />
            <Route
              exact
              path={rootPathJoin(anchor.HOME, '/:slug?')}
              component={Product}
              />
            <Route component={PageNotFound} />
          </Switch>
        </Layout>
      </LastLocationProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx